import { isArray as p } from "./code-utils.js";
export default class ge {
  constructor() {}
  tf() {}
  ef() {}
  Ta(t) {}
  static rf(t, e) {
    if (t && e)
      if (((t = t.toLowerCase()), p(e.if))) {
        for (let r = 0; r < e.if.length; r++)
          if (-1 !== t.indexOf(e.if[r].toLowerCase())) return e.identity;
      } else if (-1 !== t.indexOf(e.if.toLowerCase())) return e.identity;
  }
}
